<script setup lang="ts">
import type { PopoverArrowProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { PopoverArrow } from "reka-ui"
import { cn } from "@/lib/utils"

const props = defineProps<PopoverArrowProps & { class?: HTMLAttributes["class"] }>()

const delegatedProps = reactiveOmit(props, "class")
</script>

<template>
  <PopoverArrow v-bind="delegatedProps" :class="cn('fill-popover', props.class)" />
</template>
